import { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';

import {
  MOBILE_BREAKPOINT,
  MOBILE_SMALL_BREAKPOINT,
  TABLET_BREAKPOINT,
} from './breakpoints';

const useScreenSize = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const debouncedSetWidth = debounce(() => setWidth(window.innerWidth), 250);

    window.addEventListener('resize', debouncedSetWidth);

    return () => {
      window.removeEventListener('resize', debouncedSetWidth);
    };
  }, [setWidth]);

  return {
    isDesktop: width >= TABLET_BREAKPOINT,
    isTabletOrLarger: width >= MOBILE_BREAKPOINT,
    isTabletOrSmaller: width < TABLET_BREAKPOINT,
    isMobile: width < MOBILE_BREAKPOINT,
    isMobileSmall: width < MOBILE_SMALL_BREAKPOINT,
    width,
  };
};

export default useScreenSize;
